import React from 'react';
import ContentLayout from '../ContentLayout/ContentLayout';

const HomeContent = () => {
  return (
    <ContentLayout>
      <h3 lang="en">
        Hello! <br />
        I'm Frontend Developer. <br /> Kim Min Cheol
      </h3>
    </ContentLayout>
  );
};

export default HomeContent;
